import ActionType from 'actions/ActionType'

export default (state = { id: null, name: null }, action) => {
  switch (action.type) {
    case ActionType.Campaign.CLICK_CONTACT_COUNT:
      return action.payload ? action.payload : { id: null, name: null }
    default:
      return state
  }
}
